/* unplugin-vue-components disabled */import { render } from "./Comment.vue?vue&type=template&id=4c3d30e0&scoped=true&ts=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"

import "./Comment.vue?vue&type=style&index=0&id=4c3d30e0&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3d30e0"],['__file',"src/components/list-detail/Comment/Comment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c3d30e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c3d30e0', __exports__)) {
    console.log('reload')
    api.reload('4c3d30e0', __exports__)
  }
  
  module.hot.accept("./Comment.vue?vue&type=template&id=4c3d30e0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('4c3d30e0', render)
  })

}


export default __exports__